export enum POIControlPanelType {
  SUPERMARKETS = 'supermarkets',
  PHARMACY = 'pharmacy',
  CHILD_DAYCARE = 'childDaycare',
  RESTAURANTS = 'restaurants',
}
